if (!window.Eurus.loadedScript.has('coupon-code.js')) {
  window.Eurus.loadedScript.add('coupon-code.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xCouponCodeList", (sectionId) => ({
        loading: true,
        load() {
          this.loading = true;
          let url = `${window.location.pathname}?section_id=${sectionId}`;
          fetch(url, {
            method: 'GET'
          }).then(
            response => response.text()
          ).then(responseText => {
            const html = (new DOMParser()).parseFromString(responseText, 'text/html');
            const contentId = `x-promo-code-list-${sectionId}`;
            const newContent = html.getElementById(contentId);
            if (newContent && !document.getElementById(contentId)) {
              container.appendChild(newContent);
            }
            this.loading = false;
          })
        }
      }));
      
      Alpine.data("xCouponCode", (freeShippingCodes) => ({
        copySuccess: false,
        loading: false,
        disableCoupon: false,
        disableComing: false,
        discountCode: "",
        errorMessage: false,
        appliedDiscountCode: false,
        load(discountCode) {
          this.setAppliedButton(discountCode)
          document.addEventListener(`eurus:cart:discount-code:change`, (e) => {
            this.setAppliedButton(discountCode)
          })
        },
        copyCode() {
          if (this.copySuccess) return;

          const discountCode = this.$refs.code_value.textContent.trim();
          navigator.clipboard.writeText(discountCode).then(
            () => {
              this.copySuccess = true;
              const copyEvent = new Event('copy');
              document.dispatchEvent(copyEvent);
              
              setTimeout(() => {
                this.copySuccess = false;
              }, 5000);
            },
            () => {
              alert('Copy fail');
            }
          );
        },
        async applyCouponCode(discountCode, isCart=false) {
          const state = Alpine.store('xCouponCodeDetail');
          const code = String(discountCode || '').trim();
          if (!code || state.loading) return;
          state.discountFaild = state.discountApplied = state.discountCorrect = state.networkError = state.freeShippingApplied = false;
          state.getDiscountCode();
          const codes = [...new Set([...state.appliedDiscountCodes, code].map(value => value.trim()).filter(Boolean))];
          this.loading = state.loading = true;
          try {
            const response = await fetch('/cart/update.js', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({discount: codes.join(','), sections: Alpine.store('xCartHelper').getSectionsToRender().map(section => section.id)})
            });
            const cart = await response.json();
            if (!response.ok || cart.errors || Number(cart.status) >= 400) {
              state.discountFaild = true;
              return;
            }
            Alpine.store('xCartHelper').getSectionsToRender().forEach(section => {
              const target = document.querySelector(section.selector);
              if (target && cart.sections?.[section.id]) target.innerHTML = getSectionInnerHTML(cart.sections[section.id], section.selector);
            });
            state.appliedDiscountCodes = (cart.discount_codes || []).filter(item => item.applicable).map(item => item.code);
            document.cookie = `eurus_discount_code=${state.appliedDiscountCodes.join(',')}; path=/; SameSite=Lax`;
            const applied = state.appliedDiscountCodes.some(value => value.toLowerCase() === code.toLowerCase());
            state.discountCorrect = applied;
            state.discountFaild = !applied;
            Alpine.store('xCartHelper').currentItemCount = cart.item_count;
            document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));
            if (!isCart) {
              this.setAppliedButton(code);
              this.errorMessage = !applied;
              if (cart.item_count > 0) Alpine.store('xMiniCart').openCart();
            }
          } catch (error) {
            state.networkError = true;
          } finally {
            this.loading = state.loading = false;
            state.removedDiscountCode = '';
          }
        },
        handleScheduleCoupon(el) {
          let settings = xParseJSON(el.getAttribute('x-countdown-data'));
          let timeSettings = Alpine.store('xHelper').handleTime(settings);
          if (timeSettings.distance < 0 && settings.set_end_date) {
            this.disableCoupon = true;
          } else if ( timeSettings.startTime > timeSettings.now) {
            this.disableCoupon = true;
            this.disableComing = true;
          }
        },
        onChange() {
          this.discountCode = this.$el.value;
          const state = Alpine.store('xCouponCodeDetail');
          state.discountFaild = state.discountApplied = state.discountCorrect = state.networkError = state.freeShippingApplied = false;
        },
        applyDiscountToCart() {
          this.applyCouponCode(this.discountCode, true);
        },
        undoRemoveDiscount() {
          this.applyCouponCode(Alpine.store('xCouponCodeDetail').removedDiscountCode, true);
        },
        setAppliedButton(discountCode) {
          let appliedDiscountCodes = JSON.parse(JSON.stringify(Alpine.store('xCouponCodeDetail').appliedDiscountCodes))
          if (discountCode && appliedDiscountCodes.indexOf(discountCode) != -1) {
            this.appliedDiscountCode = true;
          } else {
            this.appliedDiscountCode = false;
          }
        }
      }));

      Alpine.store('xCouponCodeDetail', {
        show: false,
        promoCodeDetail: {},
        sectionID: "",
        discountCodeApplied: "",
        appliedDiscountCodes: [],
        removedDiscountCode: '',
        cachedResults: [],
        loading: false,
        cartEmpty: true,
        discountFaild: false,
        networkError: false,
        discountApplied: false,
        freeShippingApplied: false,
        discountCorrect: false,
        handleCouponSelect(shopUrl) {
          var _this = this;
          const promoCodeDetail = JSON.parse(JSON.stringify(this.promoCodeDetail));
  
          document.addEventListener('shopify:section:select', function(event) {
            if (event.target.classList.contains('section-promo-code') == false) {
              if (window.Alpine) {
                _this.close();
              } else {
                document.addEventListener('alpine:initialized', () => {
                  _this.close();
                });
              }
            }
          })

          if(promoCodeDetail && promoCodeDetail.blockID && promoCodeDetail.sectionID) {
            this.promoCodeDetail = xParseJSON(document.getElementById('x-data-promocode-' + promoCodeDetail.blockID).getAttribute('x-data-promocode'));
            let contentContainer = document.getElementById('PromoCodeContent-' + this.promoCodeDetail.sectionID);
            if (this.cachedResults[this.promoCodeDetail.blockID]) {
              contentContainer.innerHTML = this.cachedResults[this.promoCodeDetail.blockID];
              return true;
            }
            if (this.promoCodeDetail.page != '') {
              let url = `${shopUrl}/pages/${this.promoCodeDetail.page}`;
              fetch(url, {
                method: 'GET'
              }).then(
                response => response.text()
              ).then(responseText => {
                const html = (new DOMParser()).parseFromString(responseText, 'text/html');
                contentContainer.innerHTML = html.querySelector(".page__container .page__body").innerHTML;
              })
            } else if (this.promoCodeDetail.details != '') {
              contentContainer.innerHTML = this.promoCodeDetail.details;
              contentContainer.innerHTML = contentContainer.textContent;
            }
          }
        },
        load(el, blockID, shopUrl) {
          this.promoCodeDetail = xParseJSON(el.closest('#x-data-promocode-' + blockID).getAttribute('x-data-promocode'));
          let contentContainer = document.getElementById('PromoCodeContent-' + this.promoCodeDetail.sectionID);
          this.sectionID = this.promoCodeDetail.sectionID;
          if (this.cachedResults[blockID]) {
            contentContainer.innerHTML = this.cachedResults[blockID];
            return true;
          }
          if (this.promoCodeDetail.page != '') {
            this.loading = true;
            let url = `${shopUrl}/pages/${this.promoCodeDetail.page}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const content = html.querySelector(".page__container .page__body").innerHTML;
              contentContainer.innerHTML = content;
              this.cachedResults[blockID] = content;
            }).finally(() => {
              this.loading = false;
            })
          } else if (this.promoCodeDetail.details != '') {
            contentContainer.innerHTML = this.promoCodeDetail.details;
            contentContainer.innerHTML = contentContainer.textContent;
          }
        },
        showPromoCodeDetail() {
          this.show = true;
          Alpine.store('xPopup').open = true;
        },
        close() {
          this.show = false;
          Alpine.store('xPopup').close();
        },
        async removeDiscountCode(el, isCart=false) {
          if (this.loading) return;
          this.discountFaild = this.discountApplied = this.discountCorrect = this.networkError = false;
          this.getDiscountCode();
          const code = el.closest('li.x-discount').querySelector('.discount-title:not(.hidden)').textContent.trim();
          const codes = this.appliedDiscountCodes.filter(value => value.toLowerCase() !== code.toLowerCase());
          this.loading = true;
          try {
            const response = await fetch('/cart/update.js', {
              method: 'POST', headers: {'Content-Type':'application/json'},
              body: JSON.stringify({discount:codes.join(','),sections:Alpine.store('xCartHelper').getSectionsToRender().map(section=>section.id)})
            });
            const cart = await response.json();
            if (!response.ok || cart.errors || Number(cart.status) >= 400) throw new Error('Cart update failed');
            Alpine.store('xCartHelper').getSectionsToRender().forEach(section => {
              const target = document.querySelector(section.selector);
              if (target && cart.sections?.[section.id]) target.innerHTML = getSectionInnerHTML(cart.sections[section.id],section.selector);
            });
            this.appliedDiscountCodes = (cart.discount_codes || []).filter(item=>item.applicable).map(item=>item.code);
            document.cookie = `eurus_discount_code=${this.appliedDiscountCodes.join(',')}; path=/; SameSite=Lax`;
            this.removedDiscountCode = code;
            Alpine.store('xCartHelper').currentItemCount = cart.item_count;
            document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));
          } catch (error) {
            this.networkError = true;
          } finally {
            this.loading = false;
          }
        },
        clearRemovedDiscount() {
          this.removedDiscountCode = '';
        },
        getDiscountCode() {
          let cookieValue = document.cookie.match('(^|;)\\s*' + 'eurus_discount_code' + '\\s*=\\s*([^;]+)');
          let appliedDiscountCodes = cookieValue ? cookieValue.pop() : '';
          this.appliedDiscountCodes = appliedDiscountCodes ? appliedDiscountCodes.split(",") : [];
        }
      });
    });
  });
}
